export default "__VITE_ASSET__5432314d__"